/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Scope_UserInputs */

const en_enum_setting_scope_user = /** @type {(inputs: Enum_Setting_Scope_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope User`)
};

const de_enum_setting_scope_user = /** @type {(inputs: Enum_Setting_Scope_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

/**
* | output |
* | --- |
* | "Scope User" |
*
* @param {Enum_Setting_Scope_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_scope_user = /** @type {((inputs?: Enum_Setting_Scope_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Scope_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_scope_user(inputs)
	return de_enum_setting_scope_user(inputs)
});